import CONSTANT from "../../common/js/_constant";
import $ from 'jquery';

const pdpBannerObject = {
  variable:{
    url: window.location.href,
    category:null,
    pdpTitleComponent: $('.pdp-banner__heading'),
},
  methods :{
    handleSelection : function(el){
      $(el).find('.chli_btn--tertiary a').attr('href', $(el).find('.language_select--select').val());
      $(el).find('.language_select--select').on(CONSTANT.eventsListners.CHANGE, function(e) {
        const url = $(this).val();
        $(el).find('.chli_btn--tertiary a').attr('href', url);
      });
    },
    addClass :function(){
      document.querySelectorAll('.pdp-banner ul').forEach(ul => {
        ul.classList.add('custom-list');
      });
    },
    handleTitleFont: function() {
      const pdpTitle = pdpBannerObject.variable.pdpTitleComponent;

      const titleColor = pdpTitle.data('title-color');
      const desktopFont = pdpTitle.data('desktop-font');
      const tabletFont = pdpTitle.data('tablet-font');
      const mobileFont = pdpTitle.data('mobile-font');

      const width = window.innerWidth;
      let fontSize = desktopFont;

      if (width <= 576) {
          fontSize = mobileFont;
      } else if (width <= 992) {
          fontSize = tabletFont;
      }

      pdpTitle.css('font-size', `${fontSize}px`);
      pdpTitle.css('color', `${titleColor}`);
    },
    dataLayerObj : function(buttonText,pageSection) {
      var obj = {
          'articleName' : "",
          'blogCategory' : "",
          'blogPageCategory' : "",
          'buttonText' : buttonText.replace(/\n/g, '').trim(),
          'pageSection' : pageSection ? pageSection :"",
          'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? pdpBannerObject.variable.url.includes("blog") ? "Blogs" : pdpBannerObject.variable.url.substring(pdpBannerObject.variable.url.indexOf(".com/"), pdpBannerObject.variable.url.lastIndexOf('/')  === ".com") && !pdpBannerObject.variable.url.substring(pdpBannerObject.variable.url.indexOf(".com/"), pdpBannerObject.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
          'planOption' : "",
          'productCategory' : "",
          'productName' : "",
          'question' : "",
          'searchTerm' : "",
          'videoTitle' : "",
          'bannerName' : "",
          'bannerType' : ""
      };
      return obj;
  },
    init : function(){
      pdpBannerObject.methods.handleTitleFont();

      pdpBannerObject.variable.category=document.querySelector('#pageType').value;
      if(pdpBannerObject.variable.category!=null){
      }

      $('.pdp-banner').each((idx,el)=>{
        pdpBannerObject.methods.handleSelection(el);
        pdpBannerObject.methods.addClass();
      });
      $(".pdp-banner-ctabox .chli_btn--tertiary").on('click', function(e){
        let buttonText = e.currentTarget.innerText;
        let pageSection=$(this).closest('.pdpHeroBanner').find('.pdp-banner__heading').text();
        let obj = pdpBannerObject.methods.dataLayerObj(buttonText,pageSection);
        let href = $(this).find('a').attr('href');

        if(!href.includes('.pdf')){
          createDataLayer('buttonClick',obj);
          }

        else if(href.includes('.pdf') && pdpBannerObject.variable.category!=null && pdpBannerObject.variable.category=='Product' || pdpBannerObject.variable.category=='Category Page'){
          createDataLayer('Download_Product',obj);
        }
        else{
        createDataLayer("Download_NonProduct", obj);
        }
      });
      $(".pdp-banner-ctabox .chli_btn--primary").on('click', function(e){
        let buttonText = e.currentTarget.innerText;
        let pageSection=$(this).closest('.pdpHeroBanner').find('.pdp-banner__heading').text();
        let obj = pdpBannerObject.methods.dataLayerObj(buttonText,pageSection);
        let href = $(this).find('a').attr('href');

        if(!href.includes('.pdf')){
          createDataLayer('buttonClick',obj);
          }

        else if(href.includes('.pdf') && pdpBannerObject.variable.category!=null && pdpBannerObject.variable.category=='Product' || pdpBannerObject.variable.category=='Category Page'){
          createDataLayer('Download_Product',obj);
        }
        else{
        createDataLayer("Download_NonProduct", obj);
        }
      });
    }
  }
};


$(()=>{
  if($('.pdp-banner').length > 0){
    pdpBannerObject.methods.init();
  }
});
